import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Stack } from "@mui/material";
import { memo } from "react";
import { PaulLogoIcon } from "../../../icons/PaulLogoIcon";
import { IconByKey } from "../../IconByKey";
export var PageControls = memo(function (_a) {
    var onClose = _a.onClose;
    return (_jsxs(Stack, __assign({ spacing: 10, alignItems: "flex-start", sx: { "*": { pointerEvents: "auto" } } }, { children: [_jsx(PaulLogoIcon, { sx: { width: 96, height: 29, color: "background.paper" } }), _jsx(IconButton, __assign({ size: "large", color: "primary", sx: {
                    backgroundColor: "background.paper",
                    maxWidth: 48,
                    aspectRatio: 1,
                    "&:hover": {
                        opacity: 0.9,
                        backgroundColor: "background.paper",
                    },
                }, onClick: onClose }, { children: _jsx(IconByKey, { color: "action.active", iconKey: "arrow_left_alt" }) }))] })));
});
